import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { Injectable } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { HttpService, ApplicationInsightsService } from '@crosscutting/public_api';

import { VMNavigationService } from './vmnavigation.service';


// 5 minuten interval
const timerInterval = 300000;

@Injectable()
export class VMRefreshSessionService {
  private disable = false;
  public sessionIsExpired = false;
  private reset$ = new Subject();
  private timesExpired = 0;

  constructor(
    private _httpService: HttpService,
    private _vmnavigationService: VMNavigationService,
    private _applicationInsightsService: ApplicationInsightsService
  ) { }

  initialize(): void {
    this.reset$
      .pipe(
        startWith(void 0),
        switchMap(() => timer(timerInterval, timerInterval))
      )
      .subscribe(() => this.sessionExpired());
  }

  keepAliveAanroep(reset: boolean): void {
    const self = this;
    this._httpService.getHtml(environment.keepAliveUrl).subscribe(() => {
      if (reset) {
        self.timesExpired = 0;
      }
      self.reset$.next(void 0);
    }, () => {
      // Keep alive call MUST not result in error
      self._applicationInsightsService.logErrorWithMessage('Error when calling KeepAlive', 'KeepAlive', SeverityLevel.Warning);
    });
  }

  updateSessionTimeout(): void {
    if (!this.disable) {
      if (this.sessionIsExpired) {
        this.disable = true;
        this._vmnavigationService.navigate('sessie-verlopen');
      } else {
        this.keepAliveAanroep(true);
      }
    }
  }

  private sessionExpired(): void {
    this.timesExpired = this.timesExpired + 1;

    if (this.timesExpired >= 12) {
      this.sessionIsExpired = true;
    } else {
      this.keepAliveAanroep(false);
    }
  }
}
